import { render, staticRenderFns } from "./ForcPeerReviewCountComparison.vue?vue&type=template&id=a0a77484&"
import script from "./ForcPeerReviewCountComparison.vue?vue&type=script&lang=js&"
export * from "./ForcPeerReviewCountComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports